import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import jwtAxios, { setAuthToken, ajaxAxios } from './index';

const JWTAuthContext = createContext();
const JWTAuthActionsContext = createContext();

export const useJWTAuth = () => useContext(JWTAuthContext);

export const useJWTAuthActions = () => useContext(JWTAuthActionsContext);

const JWTAuthAuthProvider = ({
  children,
  fetchStart,
  fetchSuccess,
  fetchError,
  showMessage
}) => {
  const [firebaseData, setJWTAuthData] = useState({
    user: null,
    isAuthenticated: false,
    isLoading: true,
  });

  useEffect(() => {
    const getAuthUser = async () => {
      fetchStart();
      let token = localStorage.getItem('token');

      if (token) {
        await checkIsloginCookie();
        token = localStorage.getItem('token');
      }
      if (!token) {
        fetchSuccess();
        setJWTAuthData({
          user: undefined,
          isLoading: false,
          isAuthenticated: false,
        });
        return;
      }
      setAuthToken(token);
      jwtAxios
        .get('/account')
        .then(({ data }) => {
          fetchSuccess();
          setJWTAuthData({
            user: data.data,
            isLoading: false,
            isAuthenticated: true,
          });
        })
        .catch(() => {
          setJWTAuthData({
            user: undefined,
            isLoading: false,
            isAuthenticated: false,
          });
          fetchSuccess();
        });
    };

    getAuthUser();
  }, []);

  const checkIsloginCookie = async () => {
    try {
      const { data } = (await ajaxAxios.get('?action=ajax-cdw-check-login-state')).data;
      if (!data || data != 1) {
        localStorage.removeItem('token');
        setAuthToken();
        setJWTAuthData({
          user: null,
          isLoading: false,
          isAuthenticated: false,
        });
      }

    } catch (error) {
      localStorage.removeItem('token');
      setAuthToken();
      setJWTAuthData({
        user: null,
        isLoading: false,
        isAuthenticated: false,
      });
    }
  };
  const signInUser = async ({ username, password }) => {
    fetchStart();
    try {
      const { token } = (await jwtAxios.post('/auth/login', { username, password })).data;
      localStorage.setItem('token', token);
      setAuthToken(token);
      const res = (await jwtAxios.get('/account')).data;
      setJWTAuthData({
        user: res.data,
        isAuthenticated: true,
        isLoading: false,
      });
      fetchSuccess();
    } catch (error) {
      setJWTAuthData({
        ...firebaseData,
        isAuthenticated: false,
        isLoading: false,
      });
      fetchError(error?.response?.data?.message || 'Something went wrong');
    }
  };

  const signUpUser = async ({ name, email, password, repassword, phone }) => {
    fetchStart();
    try {
      const { token } = (await jwtAxios.post('/auth/register', { name, email, password, repassword, phone })).data;
      localStorage.setItem('token', token);
      setAuthToken(token);
      const res = (await jwtAxios.get('/account')).data;
      setJWTAuthData({
        user: res.data,
        isAuthenticated: true,
        isLoading: false,
      });
      fetchSuccess();
    } catch (error) {
      setJWTAuthData({
        ...firebaseData,
        isAuthenticated: false,
        isLoading: false,
      });
      console.log('error:', error.response.data.error);
      fetchError(error?.response?.data?.error || 'Something went wrong');
    }
  };

  const logout = async () => {
    try {
      const { message } = (await jwtAxios.post('/logout')).data;
      fetchSuccess();
      showMessage(message);

      localStorage.removeItem('token');
      setAuthToken();
      setJWTAuthData({
        user: null,
        isLoading: false,
        isAuthenticated: false,
      });
    } catch (error) {
      console.log('error:', error.response.data.message);
      fetchError(error?.response?.data?.message || 'Something went wrong');
    }
  };

  return (
    <JWTAuthContext.Provider
      value={{
        ...firebaseData,
      }}
    >
      <JWTAuthActionsContext.Provider
        value={{
          signUpUser,
          signInUser,
          logout,
        }}
      >
        {children}
      </JWTAuthActionsContext.Provider>
    </JWTAuthContext.Provider>
  );
};
export default JWTAuthAuthProvider;

JWTAuthAuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
  fetchStart: PropTypes.func,
  fetchSuccess: PropTypes.func,
  fetchError: PropTypes.func,
  showMessage: PropTypes.func
};
